(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // Subscribe footer newsletter signups straight to Klaviyo Email List T9VrnW (single opt-in),
    // exactly like the on-site popup, so they feed the Welcome flow (VRwcZa) immediately. The native
    // Shopify customer form is kept as a no-JS fallback. Public company id Ur5SWT is safe to embed.
    var form=document.getElementById('pv-news-form');
    var mount=document.getElementById('pv-news-mount');
    if(!mount) return;
    function showSuccess(){
      var f=mount.querySelector('.pv-news-form-state'),s=mount.querySelector('.pv-news-success-state');
      if(f&&s){f.hidden=true;s.hidden=false;}
    }
    // Fallback: if the native customer form ever posts (JS disabled), still show success on return.
    try{ if(new URLSearchParams(window.location.search).get('customer_posted')==='true') showSuccess(); }catch(e){}
    if(!form || form.__pvNewsWired) return; form.__pvNewsWired=1;
    var COMPANY_ID='Ur5SWT', LIST_ID='T9VrnW', REVISION='2024-10-15';
    var valid=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var input=document.getElementById('pv-news-email');
    var btn=form.querySelector('.pv-news-btn');
    function err(msg){
      var e=form.querySelector('.pv-news-err');
      if(!e){ e=document.createElement('p'); e.className='pv-news-err'; form.appendChild(e); }
      e.textContent=msg; e.hidden=false;
    }
    function sending(on){ if(btn){btn.disabled=on;btn.style.opacity=on?'0.72':'';} if(input) input.disabled=on; }
    function subscribe(email){
      if(location.hostname==='127.0.0.1'||location.hostname==='localhost'){ return new Promise(function(r){ setTimeout(r,400); }); }
      var body={data:{type:'subscription',attributes:{custom_source:'Website footer newsletter',profile:{data:{type:'profile',attributes:{email:email,properties:{pv_signup_source:'footer_newsletter'}}}}},relationships:{list:{data:{type:'list',id:LIST_ID}}}}};
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+COMPANY_ID,{method:'POST',headers:{'revision':REVISION,'content-type':'application/json'},body:JSON.stringify(body)}).then(function(r){ if(!(r.status>=200&&r.status<300)) throw new Error('klaviyo '+r.status); });
    }
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email=((input&&input.value)||'').trim();
      var ex=form.querySelector('.pv-news-err'); if(ex) ex.hidden=true;
      if(!valid.test(email)){ err('Please enter a valid email address.'); if(input) input.focus(); return; }
      sending(true);
      /* OWNER 2026-09-01: "when I subscribed at the bottom, it didn't do the animation transition where it
         does the ten percent off applying to checkout and then takes you back and shows it on the sales
         card." Correct: this form subscribed to Klaviyo and then just swapped in an inline "You're on the
         list" panel. The code was never attached to the session, so the cards never lit up and there was
         no interstitial. The popup (snippets/pv-email-popup.liquid) and the LP offer form
         (sections/pv-lp-offer.liquid) both already did the full thing; this one was the odd one out.
         Now identical to them: subscribe, play the SHARED interstitial (window.pvPlayInterstitial, defined
         by the popup snippet, which theme.liquid renders on every page), and land through
         /discount/WELCOME10 so Shopify sets the discount cookie and the cards read it on arrival.
         Destination mirrors the popup's pvDest(): stay on an energy LP, otherwise go to the funnel.
         If the interstitial is unavailable for any reason the plain redirect still applies the code, so
         the discount can never be lost to a missing animation. */
      var pvIsLP = document.documentElement.classList.contains('pv-lp');
      var pvTarget = '/discount/WELCOME10?redirect=' + encodeURIComponent(
        pvIsLP ? (location.pathname + '?promo=welcome10')
               : '/pages/methylated-b-complex-ultra?promo=welcome10');
      subscribe(email).then(function(){
        try { window.localStorage.setItem('pv_ep_sub', '1'); } catch(e){}  /* owner 2026-09-09: subscribed here = no popup, no tab (same flag the popup sets) */
        if (typeof window.pvPlayInterstitial === 'function') window.pvPlayInterstitial(pvTarget);
        else window.location.href = pvTarget;
      }).catch(function(){ sending(false); err('Something went wrong. Please try again.'); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
